import {
  ApprovedVendorsPage,
  ExtractorVendorMappingPage,
  PartFinderAttributesPage,
  PartFinderFamiliesPage,
  PartFinderFamilyPage,
  PartFinderProductTypesPage,
  UomConversionAuditPage,
} from 'companySettings/pages';

import {
  companyImportExportApprovedVendorsPath,
  companyImportExportExtractorVendorMappingPath,
  companyImportExportUomConversionAuditPath,
  partFinderAttributeListPath,
  partFinderFamilyListPath,
  partFinderFamilyPath,
  partFinderProductTypeListPath,
} from './routePaths';

const companyImportExportApprovedVendors = {
  path: companyImportExportApprovedVendorsPath(),
  exact: true,
  isPrivate: true,
  element: <ApprovedVendorsPage />,
};

const companyImportExportUomConversionAudit = {
  path: companyImportExportUomConversionAuditPath(),
  exact: true,
  isPrivate: true,
  element: <UomConversionAuditPage />,
};

const companyImportExportExtractorVendorMapping = {
  path: companyImportExportExtractorVendorMappingPath(),
  exact: true,
  isPrivate: true,
  element: <ExtractorVendorMappingPage />,
};

const partFinderAttributeList = {
  path: partFinderAttributeListPath(),
  exact: true,
  isPrivate: true,
  element: <PartFinderAttributesPage />,
};

const partFinderFamilyList = {
  path: partFinderFamilyListPath(),
  exact: true,
  isPrivate: true,
  element: <PartFinderFamiliesPage />,
};

const partFinderFamily = {
  path: partFinderFamilyPath(),
  exact: true,
  isPrivate: true,
  element: <PartFinderFamilyPage />,
};

const partFinderProductTypeList = {
  path: partFinderProductTypeListPath(),
  exact: true,
  isPrivate: true,
  element: <PartFinderProductTypesPage />,
};

export const adminRoutes = [
  companyImportExportApprovedVendors,
  companyImportExportUomConversionAudit,
  companyImportExportExtractorVendorMapping,
  partFinderAttributeList,
  partFinderProductTypeList,
  partFinderFamilyList,
  partFinderFamily,
];
